import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import EditBatchCard from './EditBatchCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { useLocation } from 'react-router';
import CreateEvent from '../Card/CreateEvent';
import CreateBatchPopUp from './CreateBatchPopUp';
import EditBatch from './EditBatch';
import DeleteBatch from './DeleteBatch';
import batchImg from '../../assets/images/batches-banner-2.png';
import { cx } from '@emotion/css';
import * as styles from './batches.style.js';
import { withAuthenticator, AmplifySignOut } from 'aws-amplify-react';

Amplify.configure(config);
function CreateClasses(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenquestion, setIsOpenquestion] = useState(false);
  const [isShowDeleteEvent, setIsShowDeleteEvent] = useState(false);

  const [batches, set_batches] = useState([]);

  const [addevents, set_addevents] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  const [eventname, set_eventname] = useState('');
  const [eventid, set_eventid] = useState('');
  const [event_category, set_event_category] = useState('');
  const [specificcategory, set_specificcategory] = useState([]);
  const [levels, set_levels] = useState([]);
  const [limits, set_limits] = useState([]);
  const [eventdisplay, set_eventdisplay] = useState('');
  const [category, set_category] = useState('');

  const [batchid, set_batchid] = useState('');
  const [batch_owner, set_batch_owner] = useState('');
  const [batch_name, set_batch_name] = useState('');
  const [students, set_students] = useState('');

  let data1 = useLocation();
  ////console.log("Calling CreateClasses.....")
  ////console.log(data1.state)

  //  const togglePopup = () => {
  //      ////console.log("Calling closing windows")
  //     setIsOpen(!isOpen);
  //   }

  function togglePopup() {
    setIsOpen(!isOpen);
  }
  function AddEvent() {
    ////console.log("Calling Creatae Classes")
    setIsOpen(!isOpen);
  }

  function computeAnswer(eventname) {
    ////console.log("REached parent screen")
    ////console.log(eventname)

    setIsOpen(!isOpen);
    set_batches([{}]);
    getToken();
  }

  function completedeletion(eventname) {
    setIsShowDeleteEvent(!isShowDeleteEvent);
    set_batches([{}]);
    getToken();
  }

  function addquestions(eventname) {
    ////console.log("We will try to add questions")
    setIsOpenquestion(!isOpenquestion);
  }

  function closeeditquestionswindow() {
    setIsOpenquestion(!isOpenquestion);
  }

  function showeditquestions(id, batch_owner, batch_name, students) {
    ////console.log(id)
    ////console.log(batch_owner)
    ////console.log(batch_name)
    ////console.log(students)

    set_batchid(id);
    set_batch_owner(batch_owner);
    set_batch_name(batch_name);
    set_students(students);
    ////console.log("We will Show edit Batch Screen")
    setIsOpenquestion(!isOpenquestion);
  }

  function showdeletebatchwindow(id, batch_owner, batch_name, students) {
    ////console.log(id)
    ////console.log(batch_owner)
    ////console.log(batch_name)

    set_batchid(id);
    set_batch_owner(batch_owner);
    set_batch_name(batch_name);
    set_students(students);
    ////console.log("Done deleting Batch")
    setIsShowDeleteEvent(!isShowDeleteEvent);
  }

  function closedeleteeventwindow() {
    setIsShowDeleteEvent(!isShowDeleteEvent);
  }

  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {




          getEventsfromDB(user.attributes['email'], jwt);
        }
        else {

          getEventsfromDB(user.username, jwt);


        }





      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }
  };


  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();
  //     //////console.log(res)
  //     //////console.log(Auth.user.username)
  //     //////console.log(props.category)
  //     //this.props.setCategory(String(Auth.user.username))

  //     getEventsfromDB(Auth.user.username, jwt);
  //   });
  // };
  const getEventsfromDB = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({ username: username }),
    };
    // ////console.log(requestOptions)
    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/listbatchesbyowner`,
      requestOptions
    );
    const data = await response.json();
    ////console.log('Output from the API is ')
    //console.log(data)

    var i, j;
    var loopData = [];
    var count = 0;
    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0])
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j];
        count = count + 1;
      }
    }

    set_batches(loopData);
    set_loadedevents(true);
  };
  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")
    getToken();
    document.title = 'Batches';
    set_addevents([{ id: 1, category: 'Create New Batch', count: 6 }]);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  let eventCards = batches.map((batch) => {
    return (
      <div key={batch.id} className="col-md-4">
        {isShowDeleteEvent && (
          <DeleteBatch
            closedeleteevents={(answer) => completedeletion(answer)}
            closedeleteeventwindow={closedeleteeventwindow}
            batch_id={batchid}
            batch_owner={batch_owner}
            batch_name={batch_name}
            students={students}
          />
        )}

        <Col className="py-2 border rounded">
          <EditBatchCard
            imgsrc={'../assets/' + batch.category + '.png'}
            name={batch.name}
            title=""
            id={batch.id}
            key={batch.id}
            category={batch.category}
            owner={batch.classowner}
            students={batch.members}
            target=""
            showeditquestions={(id, owner, name, students) =>
              showeditquestions(id, owner, name, students)
            }
            showdeletebatch={(batch_id, batch_owner, batch_name, students) =>
              showdeletebatchwindow(batch_id, batch_owner, batch_name, students)
            }
          />
        </Col>
      </div>
    );
  });

  let addeventCards = addevents.map((eventcategory) => {
    return (
      <>
        <div key="123" className={`${cx(styles.batchesCols)} col-md-4`}>
          {isOpen && (
            <CreateBatchPopUp
              handleClose={togglePopup}
              selected={(answer) => computeAnswer(answer)}
            />
          )}
          {isOpenquestion && <EditBatch />}
          <Col className="py-2 border rounded" key="123">
            <CreateEvent
              imgsrc={'../assets/' + eventcategory.category + '.png'}
              title="Algebra"
              key="12344"
              eventcategory={eventcategory}
              target="events"
              onclick={(dummyvar) => AddEvent()}
            />
          </Col>
        </div>
      </>
    );
  });

  return (
    <div key="124">
      {loadedevents ? (
        <div>
          <div>
            <div className={cx(styles.batchBanner)}>
              <img src={batchImg} alt="" />

            </div>
            <div className={cx(styles.batchTitle)}>Create Batches</div>
            <div className={cx(styles.cardFluid)}>
              <Row>
                {addeventCards}
                {eventCards}
              </Row>
            </div>
          </div>
        </div>
      ) : (
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      )}
    </div>
  );
}


export default CreateClasses;

